module.exports = __webpack_public_path__ + "static/media/icon-copy.11734a10.svg";